import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const QUESTIONS = [1, 2, 3, 4, 5, 6, 7, 8];

export const FAQ = () => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative py-24 md:py-32 px-5 md:px-10 lg:px-16" data-testid="faq-section">
      <div className="max-w-[1100px] mx-auto">
        <div className="mb-14 md:mb-16 max-w-2xl">
          <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#A9824A] mb-3">
            · 14 / FAQ
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter text-[#F5F1EA] leading-[0.98]">
            {t("faqTitle")}
          </h2>
          <p className="mt-5 text-[15px] text-[#E6E0D6]/80 leading-relaxed">{t("faqSub")}</p>
        </div>

        <div className="space-y-3">
          {QUESTIONS.map((n, i) => {
            const isOpen = open === i;
            return (
              <div
                key={n}
                className={`rounded-2xl border transition-colors duration-300 ${isOpen ? "border-[#D7B56D]/35 bg-[#15171c]" : "border-[#D8DCE2]/8 bg-[#15171c]/55 hover:border-[#D8DCE2]/14"}`}
                data-testid={`faq-item-${n}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center gap-4 p-5 md:p-6 text-start"
                  data-testid={`faq-toggle-${n}`}
                >
                  <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#A9824A] w-8 shrink-0">
                    {String(n).padStart(2, "0")}
                  </span>
                  <span className="font-display text-base md:text-lg font-bold text-[#F5F1EA] flex-1">
                    {t(`faq${n}Q`)}
                  </span>
                  <span className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-colors duration-200 ${isOpen ? "bg-[#D7B56D] text-[#0a0b0f]" : "bg-[#0a0b0f] text-[#D7B56D]"}`}>
                    {isOpen ? <Minus size={14} /> : <Plus size={14} />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <div className="px-5 md:px-6 pb-5 md:pb-6 pl-[68px]">
                        <p className="text-[14px] text-[#E6E0D6]/85 leading-relaxed">{t(`faq${n}A`)}</p>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>

        <p className="mt-12 text-[12px] text-[#D8DCE2]/45 leading-relaxed">{t("disclaimer")}</p>
      </div>
    </section>
  );
};
